<template>
  <div class="content">
    <h5-header :header-msg="headerMsg"></h5-header>

    <div class="state">
      <img src="../../assets/img/icon_pay_tickBig.png" alt />
      <p>{{detailObj.stallName}}</p>
      <p>- ￥{{detailObj.money}}</p>
    </div>

    <div class="msg">
      <p>
        <span>支付时间</span>
        <span>{{detailObj.payDate}}</span>
      </p>
      <p>
        <span>订单号</span>
        <span>{{detailObj.orderSn}}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { msgPayDetails } from "@/api/picker/index";
export default {
  data() {
    return {
      headerMsg: {
        title: "支付详情",
        url: ""
      },
      id: "", //支付详情id
      detailObj: {} //支付详情对象
    };
  },
  mounted() {
    // this.id = this.$route.query.id;
    this.msgPayDetails(this.GetQueryString("id"));
  },
  methods: {
    msgPayDetails(id) {
      let obj = {
        token: this.$store.getters.token || this.GetQueryString("token"),
        id
      };
      msgPayDetails(obj).then(res => {
        if (res.appStatus.errorCode == 0) {
          this.detailObj = res.content;
          return;
        }
        this.$toast(res.appStatus.message);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  p {
    margin: 0;
  }
  .state {
    width: auto;
    height: 263.5px;
    margin: 0 12px 20px;
    border-bottom: 1px solid #cfcfcf;
    img {
      width: 105px;
      height: 105px;
      display: block;
      margin: 30px auto 22px;
    }
    .col {
      color: #ec130c;
    }
    p:nth-child(2) {
      display: inline-block;
      color: #1d1d1d;
      font-size: 20px;
    }
    p:last-child {
      color: #333;
      font-size: 30px;
      margin-top: 15px;
    }
  }
  .msg {
    text-align: left;
    p {
      width: auto;
      height: 20px;
      line-height: 20px;
      padding: 0 12px;
      display: flex;
      font-size: 15px;
      span {
        display: block;
      }
      span:first-child {
        width: 70px;
        color: #666;
        margin-right: 25px;
      }
      span:last-child {
        color: #333;
      }
    }
    > p:last-child {
      margin-top: 15px;
    }
  }
}
</style>

